import React from 'react';
import Footer from '../Footer';

const Reports = () => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh', // Ensure full height of the viewport
      }}
    >
      {/* Main Content */}
      <div style={{ flex: 1, padding: "20px 30px" }}>
        {/* First Report Section */}
        <div style={{ marginBottom: "30px", display: "flex", alignItems: "center" }}>
          <h2
            style={{
              textAlign: "left",
              fontSize: "1.5rem",
              fontFamily: 'Inter',
              marginBottom: "0",
              marginTop: "10px",
              marginRight: "10px",
            }}
          >
            Annual Report : 2015-18
          </h2>
          <a
            href="https://drive.google.com/file/d/1j_pkhL54vLDopML8zaBqVB1Eed_HvhnC/view?usp=drive_link"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              textDecoration: "none",
              color: "#ffffff",
              backgroundColor: "#28A745",
              padding: "10px 20px",
              borderRadius: "5px",
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            Annual Report : 2015-18
          </a>
        </div>

        {/* Second Report Section */}
        <div style={{ display: "flex", alignItems: "center" }}>
          <h2
            style={{
              textAlign: "left",
              fontSize: "1.5rem",
              fontFamily: 'Inter',
              marginBottom: "0",
              marginTop: "10px",
              marginRight: "10px",
            }}
          >
            Annual Report : 2013-14
          </h2>
          <a
            href="https://drive.google.com/file/d/19oLRCRjjAJT0ozC1-GFAXtOcvUOwfL6X/view?usp=drive_link"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              textDecoration: "none",
              color: "#ffffff",
              backgroundColor: "#28A745",
              padding: "10px 20px",
              borderRadius: "5px",
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            Annual Report : 2013-14
          </a>
        </div>
      </div>

      {/* Footer at the Bottom */}
      <Footer />
    </div>
  );
};

export default Reports;

